const validate = (values) => {
  const errors = {};

  if (!values.shapes || values.shapes.length === 0) {
    errors.shapes = 'Selecione ao menos um responsável, turma ou aluno';
  }

  return errors;
};

export default validate;
